module.exports = __webpack_public_path__ + "img/SLOVA.7556fd9f.svg";